// How many hung rows show before the fold, and which come first (no React:
// the lists' row builders use it). Drawn by `list-tree.tsx`.

/** Rows shown before the fold. */
export const FOLD_AT = 5;

/**
 * The order to draw hung rows in: as they are, or past FOLD_AT the ones that
 * want the person first (lower `rank`), each kept in its order, so they are
 * not folded away.
 */
export function foldOrder<T>(
  rows: readonly T[],
  rank: (row: T) => number,
): T[] {
  if (rows.length <= FOLD_AT) return [...rows];
  return rows
    .map((row, at) => ({ row, at, r: rank(row) }))
    .sort((a, b) => a.r - b.r || a.at - b.at)
    .map(({ row }) => row);
}
